import React from 'react';
import NotificationSystem from 'react-notification-system';
import { useSelector } from 'react-redux';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { Tooltip } from 'react-tooltip';
import { h } from '@debbie/cortex/dist/index.js';
import { notifications } from '@debbie/cortex/dist/index.js';
import AccountSelectorPage from './AccountSelectorPage/AccountSelectorPage.js';
import GlobalStyle from './GlobalStyle.js';
import MoneyCalculator from './MoneyCalculator.js';
import { Welcome } from './index.js';
const X = (props) => {
    const isAuthTokenLoaded = useSelector((s) => h.isLoaded(s.authToken));
    return (React.createElement(React.Fragment, null,
        React.createElement(Router, null,
            React.createElement(Switch, null,
                props.routes,
                React.createElement(Route, { path: "/account-selector" },
                    React.createElement(AccountSelectorPage, null)),
                React.createElement(Route, { path: "/" },
                    React.createElement("div", null,
                        React.createElement(Welcome, { logo: props.logo, hide: isAuthTokenLoaded }),
                        isAuthTokenLoaded && props.loggedInView)))),
        React.createElement(MoneyCalculator, null),
        React.createElement(Tooltip, { id: "tooltip-default" }),
        React.createElement(Tooltip, { id: "tooltip-top", place: "top" }),
        React.createElement(Tooltip, { id: "tooltip-left", place: "left" }),
        React.createElement(Tooltip, { id: "tooltip-bottom", place: "bottom" }),
        React.createElement(GlobalStyle, null),
        React.createElement(NotificationSystem, { ref: (r) => notifications.attachNotificationHandler(r) })));
};
export default X;
//# sourceMappingURL=X.js.map